import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const toggle = this.element.querySelector('.password-toggle');
        const input = this.element.querySelector('input[type="password"]');

        toggle.addEventListener('click', (e) => {
             e.preventDefault();
             const inputType = input.getAttribute('type');

             if (inputType === 'password') {
                this.element.classList.add('password-visible');
                input.setAttribute('type', 'text');
             } else {
                this.element.classList.remove('password-visible');
                input.setAttribute('type', 'password');
             }
        });
    }
}